import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/images/user-6.jpg'
import _imports_1 from '@/assets/images/user-7.jpg'
import _imports_2 from '@/assets/images/user-8.jpg'
import _imports_3 from '@/assets/images/user-9.jpg'
import _imports_4 from '@/assets/images/user-10.jpg'
import _imports_5 from '@/assets/images/user-11.jpg'


const _hoisted_1 = { class: "card bg-white border-0 rounded-3 mb-4" }
const _hoisted_2 = { class: "card-body p-0" }
const _hoisted_3 = { class: "default-table-area style-two top-instructors" }
const _hoisted_4 = { class: "table-responsive" }
const _hoisted_5 = { class: "table align-middle border-0" }
const _hoisted_6 = { class: "text-end pt-1" }
const _hoisted_7 = { class: "text-end" }
const _hoisted_8 = { class: "text-end" }
const _hoisted_9 = { class: "text-end" }
const _hoisted_10 = { class: "text-end" }
const _hoisted_11 = { class: "text-end" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_RouterLink = _resolveComponent("RouterLink")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[12] || (_cache[12] = _createStaticVNode("<div class=\"p-4\"><div class=\"d-flex justify-content-between align-items-center flex-wrap gap-3\"><h3 class=\"mb-0\">Followers</h3><div class=\"dropdown action-opt\"><button class=\"btn bg-transparent p-0\" type=\"button\" data-bs-toggle=\"dropdown\" aria-expanded=\"false\"><i data-feather=\"more-horizontal\"></i></button><ul class=\"dropdown-menu dropdown-menu-end bg-white border box-shadow\"><li><a class=\"dropdown-item\" href=\"javascript:;\"><i data-feather=\"clock\"></i> Today </a></li><li><a class=\"dropdown-item\" href=\"javascript:;\"><i data-feather=\"pie-chart\"></i> Last 7 Days </a></li><li><a class=\"dropdown-item\" href=\"javascript:;\"><i data-feather=\"rotate-cw\"></i> Last Month </a></li><li><a class=\"dropdown-item\" href=\"javascript:;\"><i data-feather=\"calendar\"></i> Last 1 Year </a></li><li><a class=\"dropdown-item\" href=\"javascript:;\"><i data-feather=\"bar-chart\"></i> All Time </a></li><li><a class=\"dropdown-item\" href=\"javascript:;\"><i data-feather=\"eye\"></i> View </a></li><li><a class=\"dropdown-item\" href=\"javascript:;\"><i data-feather=\"trash\"></i> Delete </a></li></ul></div></div></div>", 1)),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("table", _hoisted_5, [
            _createElementVNode("tbody", null, [
              _createElementVNode("tr", null, [
                _cache[1] || (_cache[1] = _createElementVNode("td", { class: "pt-1" }, [
                  _createElementVNode("div", { class: "d-flex align-items-center" }, [
                    _createElementVNode("div", { class: "flex-shrink-0" }, [
                      _createElementVNode("img", {
                        src: _imports_0,
                        class: "wh-44 rounded-circle",
                        alt: "user"
                      })
                    ]),
                    _createElementVNode("div", { class: "flex-grow-1 ms-2 position-relative top-2" }, [
                      _createElementVNode("h6", { class: "mb-0 fs-14 fw-medium" }, "Alex Davis"),
                      _createElementVNode("span", { class: "fs-12 text-body" }, "alex@trezo.com")
                    ])
                  ])
                ], -1)),
                _createElementVNode("td", _hoisted_6, [
                  _createVNode(_component_RouterLink, {
                    to: "/my-profile",
                    class: "wh-35 d-inline-block border text-center lh-35 rounded-circle text-decoration-none hover-bg"
                  }, {
                    default: _withCtx(() => [...(_cache[0] || (_cache[0] = [
                      _createElementVNode("i", { class: "ri-arrow-right-up-line fs-18" }, null, -1)
                    ]))]),
                    _: 1
                  })
                ])
              ]),
              _createElementVNode("tr", null, [
                _cache[3] || (_cache[3] = _createElementVNode("td", null, [
                  _createElementVNode("div", { class: "d-flex align-items-center" }, [
                    _createElementVNode("div", { class: "flex-shrink-0" }, [
                      _createElementVNode("img", {
                        src: _imports_1,
                        class: "wh-44 rounded-circle",
                        alt: "user"
                      })
                    ]),
                    _createElementVNode("div", { class: "flex-grow-1 ms-2 position-relative top-2" }, [
                      _createElementVNode("h6", { class: "mb-0 fs-14 fw-medium" }, "Laura Martinez"),
                      _createElementVNode("span", { class: "fs-12 text-body" }, "laura@trezo.com")
                    ])
                  ])
                ], -1)),
                _createElementVNode("td", _hoisted_7, [
                  _createVNode(_component_RouterLink, {
                    to: "/my-profile",
                    class: "wh-35 d-inline-block border text-center lh-35 rounded-circle text-decoration-none hover-bg"
                  }, {
                    default: _withCtx(() => [...(_cache[2] || (_cache[2] = [
                      _createElementVNode("i", { class: "ri-arrow-right-up-line fs-18" }, null, -1)
                    ]))]),
                    _: 1
                  })
                ])
              ]),
              _createElementVNode("tr", null, [
                _cache[5] || (_cache[5] = _createElementVNode("td", null, [
                  _createElementVNode("div", { class: "d-flex align-items-center" }, [
                    _createElementVNode("div", { class: "flex-shrink-0" }, [
                      _createElementVNode("img", {
                        src: _imports_2,
                        class: "wh-44 rounded-circle",
                        alt: "user"
                      })
                    ]),
                    _createElementVNode("div", { class: "flex-grow-1 ms-2 position-relative top-2" }, [
                      _createElementVNode("h6", { class: "mb-0 fs-14 fw-medium" }, "Mark Thompson"),
                      _createElementVNode("span", { class: "fs-12 text-body" }, "mark@trezo.com")
                    ])
                  ])
                ], -1)),
                _createElementVNode("td", _hoisted_8, [
                  _createVNode(_component_RouterLink, {
                    to: "/my-profile",
                    class: "wh-35 d-inline-block border text-center lh-35 rounded-circle text-decoration-none hover-bg"
                  }, {
                    default: _withCtx(() => [...(_cache[4] || (_cache[4] = [
                      _createElementVNode("i", { class: "ri-arrow-right-up-line fs-18" }, null, -1)
                    ]))]),
                    _: 1
                  })
                ])
              ]),
              _createElementVNode("tr", null, [
                _cache[7] || (_cache[7] = _createElementVNode("td", null, [
                  _createElementVNode("div", { class: "d-flex align-items-center" }, [
                    _createElementVNode("div", { class: "flex-shrink-0" }, [
                      _createElementVNode("img", {
                        src: _imports_3,
                        class: "wh-44 rounded-circle",
                        alt: "user"
                      })
                    ]),
                    _createElementVNode("div", { class: "flex-grow-1 ms-2 position-relative top-2" }, [
                      _createElementVNode("h6", { class: "mb-0 fs-14 fw-medium" }, "Rachel White"),
                      _createElementVNode("span", { class: "fs-12 text-body" }, "rachel@trezo.com")
                    ])
                  ])
                ], -1)),
                _createElementVNode("td", _hoisted_9, [
                  _createVNode(_component_RouterLink, {
                    to: "/my-profile",
                    class: "wh-35 d-inline-block border text-center lh-35 rounded-circle text-decoration-none hover-bg"
                  }, {
                    default: _withCtx(() => [...(_cache[6] || (_cache[6] = [
                      _createElementVNode("i", { class: "ri-arrow-right-up-line fs-18" }, null, -1)
                    ]))]),
                    _: 1
                  })
                ])
              ]),
              _createElementVNode("tr", null, [
                _cache[9] || (_cache[9] = _createElementVNode("td", null, [
                  _createElementVNode("div", { class: "d-flex align-items-center" }, [
                    _createElementVNode("div", { class: "flex-shrink-0" }, [
                      _createElementVNode("img", {
                        src: _imports_4,
                        class: "wh-44 rounded-circle",
                        alt: "user"
                      })
                    ]),
                    _createElementVNode("div", { class: "flex-grow-1 ms-2 position-relative top-2" }, [
                      _createElementVNode("h6", { class: "mb-0 fs-14 fw-medium" }, "Kevin Lee"),
                      _createElementVNode("span", { class: "fs-12 text-body" }, "kevin@trezo.com")
                    ])
                  ])
                ], -1)),
                _createElementVNode("td", _hoisted_10, [
                  _createVNode(_component_RouterLink, {
                    to: "/my-profile",
                    class: "wh-35 d-inline-block border text-center lh-35 rounded-circle text-decoration-none hover-bg"
                  }, {
                    default: _withCtx(() => [...(_cache[8] || (_cache[8] = [
                      _createElementVNode("i", { class: "ri-arrow-right-up-line fs-18" }, null, -1)
                    ]))]),
                    _: 1
                  })
                ])
              ]),
              _createElementVNode("tr", null, [
                _cache[11] || (_cache[11] = _createElementVNode("td", null, [
                  _createElementVNode("div", { class: "d-flex align-items-center" }, [
                    _createElementVNode("div", { class: "flex-shrink-0" }, [
                      _createElementVNode("img", {
                        src: _imports_5,
                        class: "wh-44 rounded-circle",
                        alt: "user"
                      })
                    ]),
                    _createElementVNode("div", { class: "flex-grow-1 ms-2 position-relative top-2" }, [
                      _createElementVNode("h6", { class: "mb-0 fs-14 fw-medium" }, "Anne Dew"),
                      _createElementVNode("span", { class: "fs-12 text-body" }, "anne@trezo.com")
                    ])
                  ])
                ], -1)),
                _createElementVNode("td", _hoisted_11, [
                  _createVNode(_component_RouterLink, {
                    to: "/my-profile",
                    class: "wh-35 d-inline-block border text-center lh-35 rounded-circle text-decoration-none hover-bg"
                  }, {
                    default: _withCtx(() => [...(_cache[10] || (_cache[10] = [
                      _createElementVNode("i", { class: "ri-arrow-right-up-line fs-18" }, null, -1)
                    ]))]),
                    _: 1
                  })
                ])
              ])
            ])
          ])
        ])
      ]),
      _cache[13] || (_cache[13] = _createStaticVNode("<div class=\"p-4\"><div class=\"d-flex justify-content-center justify-content-sm-between align-items-center text-center flex-wrap gap-2 showing-wrap\"><span class=\"fs-12 fw-medium\">Items per pages: 6</span><div class=\"d-flex align-items-center\"><span class=\"fs-12 fw-medium me-2\">1 - 6 of 12</span><nav aria-label=\"Page navigation example\"><ul class=\"pagination mb-0 justify-content-center\"><li class=\"page-item\"><a class=\"page-link icon\" href=\"#\" aria-label=\"Previous\"><i class=\"material-symbols-outlined\">keyboard_arrow_left</i></a></li><li class=\"page-item\"><a class=\"page-link icon\" href=\"#\" aria-label=\"Next\"><i class=\"material-symbols-outlined\"> keyboard_arrow_right </i></a></li></ul></nav></div></div></div>", 1))
    ])
  ]))
}